
import { getAuthToken } from "../../services/authService-sighup";

export const getHeaders = async () => {
  const token = await getAuthToken();

  return {
    Authorization: `Bearer ${token}`,
    "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUBSCRIPTION_KEY_METADATA ?? "",
    Product: process.env.REACT_APP_PRODUCT_APIM ?? "",
    'X-Entitlement-Domain': 'amp',
    'X-Entitlement-Service': 'general_amp_service',
  };
};
